import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './Component/Navbar/Header';
import Home from './Pages/Home';
import AboutPage from './Pages/AboutPage';
import ContactPage from './Pages/ContactPage';
import ProductPage from './Pages/ProductPage';
import ProductDetails from './Pages/ProductDetails';
import Account from './Pages/Account';
import ForgotPassword from "./Component/account/ForgotPassword";
import NavBar from './Component/AppComponent/Header/NavBar';
import Order from './Component/OrderCom/Order';
import AppProfile from './Component/AppComponent/AppProfile';
import CheckOutPage from './Pages/CheckOutPage';
import FooterNav from './Component/AppComponent/Footer/FooterNav';
import SuccessPage from './Pages/SuccessPage';
import FailedPage from './Pages/FailedPage';
import ProductList from './Pages/ProductList';
import Termsandconditions from './Pages/Termsandconditions';
import TermsConditions from './Pages/TermsConditions';
import ReturnPolicy from './Pages/ReturnPolicy';
import Shipping from './Pages/Shipping';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import WhatsAppIcons from './Component/WhatsAppIcons';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <Header /> */}
        {/* <NavBar/> */}
        <WhatsAppIcons/>
        <Routes>
          <Route path='/' element={<><NavBar /><Home /></>} />
          {/* <Route path='/product/:subcategory' element={<><NavBar /><ProductPage /></>} /> */}
          <Route path='/about' element={<><NavBar /><AboutPage /></>} />
          <Route path='/product-details/:slug' element={<><NavBar /><ProductDetails /></>} />
          <Route path='/contact' element={<><NavBar /><ContactPage /></>} />
          <Route path="/account/:page" element={<Account />} />
          <Route path='/account/forgot-password' element={<ForgotPassword />} />
          <Route path='/order' element={<Order />} />
          <Route path='/CheckOutPage' element={<><NavBar /><CheckOutPage /></>} />
          {/* <Route path='/profile' element={<AppProfile/>}/> */}
          <Route path='/profile' element={<Order />} />
          <Route path='/order-success/:orderId' element={<SuccessPage />} />
          <Route path='/order-failed/:order_id' element={<FailedPage />} />

          <Route path='/product' element={<><NavBar /><ProductPage /></>} />
          <Route path="/product/:category" element={<><NavBar /><ProductList /></>} />
          <Route path="/product/:category/:subcategory" element={<><NavBar /><ProductList /></>} />
          <Route path='/policies' element={<><NavBar /><Termsandconditions /></>} />
          <Route path='/terms-conditions' element={<><NavBar /><TermsConditions /></>} />
          <Route path='/return-policy' element={<><NavBar /><ReturnPolicy /></>} />
          <Route path='/shipping' element={<><NavBar /><Shipping /></>} />
          <Route path='/return-policy' element={<><NavBar /><ReturnPolicy /></>} />
          <Route path='/privacy-policy' element={<><NavBar /><PrivacyPolicy /></>} />
        </Routes>
        <FooterNav />
      </BrowserRouter>
    </div>
  );
}

export default App;
